var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:gray;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.78,35.79c.03-5.23,1.51-6.84,4.08-8.44,1.76-1.1,3.11-2.5,3.11-4.53,0-2.28-1.79-3.76-4.01-3.76-2.05,0-4.02,1.31-4.15,4.04h-5.17c.14-5.52,4.27-8.33,9.35-8.33,5.55,0,9.36,3.08,9.36,7.99,0,3.32-1.67,5.5-4.34,7.1-2.37,1.45-3.37,2.86-3.4,5.94v.38h-4.83v-.38Zm-.65,6.24c-.01-1.74,1.42-3.17,3.19-3.17s3.18,1.42,3.19,3.17c-.01,1.77-1.48,3.19-3.19,3.19s-3.21-1.42-3.19-3.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScIcon);
export default __webpack_public_path__ + "static/media/sc_icon.63280055b864c3378563b993f2778392.svg";
export { ForwardRef as ReactComponent };